<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">

        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Condición ..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                  <b-button variant="primary" class="ml-5" v-on:click="agregarRegistro">Agregar</b-button>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  :items="registros"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="_onFiltered"
                  :bordered="true" :hover="true"
              >
                <template #cell(edicion)="data">
                  <div class="btn-group btn-group-sm" role="group" aria-label="Acciones">
                    <button type="button" class="btn btn-success" v-on:click="edicionRegistro(data.item.idservicio)">Editar</button>
                    <button type="button" class="btn btn-danger"
                            v-on:click="eliminacionRegistro(data.item)">Eliminar</button>
                  </div>
                </template>
                <template #cell(activo)="data">
                  <div style="text-align: center">
                    <i class="bx bx-check-circle" style="color: darkgreen" v-if="data.item.activo == 1"></i>
                    <i class="bx bx-x-circle" style="color: red" v-if="data.item.activo == 0"></i>
                  </div>
                </template>
                <template #cell(atributos)="data">
                  <div style="text-align: left">
                    <li style="font-size: 9px" v-if="data.item.reemplazaest">Reemplaza valor estacionamiento</li>
                    <li style="font-size: 9px" v-if="data.item.valorvariable">Valor variable</li>
                    <li style="font-size: 9px" v-if="data.item.descuento">Descuento por uso del servicio</li>
                  </div>
                </template>

              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div v-if="editarRegistro">
      <b-modal id="modalServicios" size="lg" :hide-footer="true" v-model="editarRegistro" title='Servicios'>
        <modal-servicio :id="id" @updateServicios="cerrarRegistro"></modal-servicio>
      </b-modal>
    </div>

  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {serviciosService} from "../../../helpers/servicios/configuracion/servicios.service";
import ModalServicio from "../../../components/configuracion/modalServicio";

export default {
  name: "servicios",
  page: {
    title: "Servicios",
    meta: [{ name: "description", content: appConfig.description}]
  },
  components: {
    ModalServicio,
    Layout, PageHeader
  },
  computed: {
    rows()  {
      return this.registros.length
    }
  },
  data()  {
    return {
      title: "Servicios",
      items: [ { text: "Principal", href: "/"}, { text: "Configuración "}, { text: "Servicios", active: true }],
      registros: [], id: null,
      editarRegistro: false,
      /* tabla */
      currentPage: 1, perPage: 10, pageOptions: [10,25,50,100], filter: null, filterOn: [],
      fields: [

        { key: "sucursal", label: "Sucursal", sortable: true },
        { key: "descripcion", label: "Servicio", sortable: true },
        { key: "atributos", label: "Atributos", sortable: true},
        // { key: "reemplazaest", label: "Reemplazaest", sortable: true },
        // { key: "valorvariable", label: "Valorvariable", sortable: true },
        // { key: "descuento", label: "Descuento", sortable: true },
        { key: "activo", label: "Activo", sortable: true },

        { key: "edicion", label: "Acción", sortable: true}

      ],
      sortBy: "sucursal", sortDesc: false, totalRows: 0
    }
  },
  mounted() {
    this.listarRegistros()
  },
  methods: {
    listarRegistros() {
      serviciosService.listarServicios().then((response) => {
        this.registros = response;
      }).catch((error) => {
        this._mensaje("danger", "Servicios", error.mensaje);
      })
    },
    agregarRegistro()  {
      this.edicionRegistro(null);
    },
    edicionRegistro(id) {
      this.id = id;
      this.editarRegistro = true;
    },
    eliminacionRegistro(item)  {
      this.id = item.idservicio;
      this.$bvModal.msgBoxConfirm("Está seguro/a de eliminar a " + item.descripcion, {
        title: "Eliminar Servicios",
        okVariant: "danger",
        okTitle: "Eliminar",
        cancelTitle: "Cancelar"
      }).then((value) => {
        if (value) {
          this.eliminarServicios(this.id)
        }
      })
    },
    eliminarServicios(id) {
      serviciosService.eliminarServicios(id).then((response) => {
        this._mensaje("success", "Eliminar Servicios", response.mensaje)
        this.listarRegistros()
      }).catch((error) => {
        this._mensaje("danger", "Eliminar Servicios", error.mensaje)
      })
    },
    cerrarRegistro(reload) {
      this.editarRegistro = false
      if (reload)  {
        this._mensaje("success", "La servicio ha sido guardado")
        this.listarRegistros()
      }
    },

    _onFiltered(filteredItems)  {
      this.totalRows = filteredItems.length
      this.currentPage = 1

    },
    _mensaje(color, titulo, mensaje)  {
      this.$bvToast.toast(mensaje, {
        title: titulo, variant: color, solid: true
      })
    }

  }
}
</script>

<style scoped>

</style>
